import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchOrganizationTypes, createOrganizationType, fetchOrganizationType, modifyOrganizationType, deleteOrganizationTypeApi, changeStatus } from '../../api/organizationTypeApi';

export const getOrganizationTypes = createAsyncThunk('organizationType/getOrganizationTypes', async ({payload}, { rejectWithValue }) => {
  try {
    const response = await fetchOrganizationTypes(payload);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const addOrganizationType = createAsyncThunk('organizationType/addOrganizationType', async (payload, { rejectWithValue }) => {
  try {
    const response = await createOrganizationType(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getOrganizationTypeDetails = createAsyncThunk('organizationType/getOrganizationTypeDetails', async (organizationTypeId, { rejectWithValue }) => {
  try {
    const response = await fetchOrganizationType(organizationTypeId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const updateOrganizationType = createAsyncThunk('organizationType/updateOrganizationType', async (payload, { rejectWithValue }) => {
  try {
    const response = await modifyOrganizationType(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const deleteOrganizationType = createAsyncThunk('organizationType/deleteOrganizationType', async (organizationTypeId, { rejectWithValue }) => {
  try {
    const response = await deleteOrganizationTypeApi(organizationTypeId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const changeActiveStatus = createAsyncThunk('organizationType/changeDefaultStatus', async (organizationTypeId, { rejectWithValue }) => {
  try {
    const response = await changeStatus(organizationTypeId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const organizationTypeSlice = createSlice({
  name: 'organizationType',
  initialState: {
    organizationTypes: [],
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrganizationTypes.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getOrganizationTypes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.organizationTypes = action.payload;
      })
      .addCase(getOrganizationTypes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
  },
});

export default organizationTypeSlice.reducer;
